import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as NotficationActions from './actions';

export default connect(null, dispatch => bindActionCreators({
  addSuccess: NotficationActions.addSuccess,
  addError: NotficationActions.addError,
}, dispatch));
